import { IAction, IOfficeVisit } from '@shared-components/models';
import * as actionType from './office-visit.constant';

export const addOfficeVisitRequest = (
  payload: IOfficeVisit,
  triggerRefresh?: () => void
): IAction<IOfficeVisit> => ({
  type: actionType.ADD_OFFICE_VISIT_REQUEST,
  payload,
  triggerRefresh,
});

export const addOfficeVisitSuccess = (): IAction<IOfficeVisit> => ({
  type: actionType.ADD_OFFICE_VISIT_SUCCESS,
});

export const addOfficeVisitFailure = (err: any): IAction<IOfficeVisit> => ({
  type: actionType.ADD_OFFICE_VISIT_FAILURE,
  payload: err,
});

export const getOfficeVisitRequest = (id: string): IAction<IOfficeVisit> => ({
  type: actionType.GET_OFFICE_VISIT_REQUEST,
  id,
});

export const getOfficeVisitSuccess = (
  payload: IOfficeVisit
): IAction<IOfficeVisit> => ({
  type: actionType.GET_OFFICE_VISIT_SUCCESS,
  payload,
});

export const getOfficeVisitFailure = (err: any): IAction<IOfficeVisit> => ({
  type: actionType.GET_OFFICE_VISIT_FAILURE,
  payload: err,
});

export const updateOfficeVisitRequest = (
  id: string,
  payload: IOfficeVisit,
  triggerRefresh?: () => void
): IAction<IOfficeVisit> => ({
  type: actionType.UPDATE_OFFICE_VISIT_REQUEST,
  id,
  payload,
  triggerRefresh,
});

export const updateOfficeVisitSuccess = (): IAction<IOfficeVisit> => ({
  type: actionType.UPDATE_OFFICE_VISIT_SUCCESS,
});

export const updateOfficeVisitFailure = (err: any): IAction<IOfficeVisit> => ({
  type: actionType.UPDATE_OFFICE_VISIT_FAILURE,
  payload: err,
});

export const clearOfficeVisitSingleData = (): IAction<IOfficeVisit> => ({
  type: actionType.CLEAR_OFFICE_VISIT_DATA,
});

export const openOfficeVisitDrawer = (): IAction<IOfficeVisit> => ({
  type: actionType.OPEN_OFFICE_VISIT_DRAWER,
});

export const closeOfficeVisitDrawer = (): IAction<IOfficeVisit> => ({
  type: actionType.CLOSE_OFFICE_VISIT_DRAWER,
});

export const openOfficeVisitDetailsDrawer = (): IAction<IOfficeVisit> => ({
  type: actionType.OPEN_OFFICE_VISIT_DETAILS_DRAWER,
});

export const closeOfficeVisitDetailsDrawer = (): IAction<IOfficeVisit> => ({
  type: actionType.CLOSE_OFFICE_VISIT_DETAILS_DRAWER,
});

export const officeVisitTableRefresh = (): IAction<IOfficeVisit> => ({
  type: actionType.OFFICE_VISIT_TABLE_REFRESH,
});
